import { CurrentTeamGq } from '../../graphql/users/models/CurrentTeamGq';

export function useKeywordCapacityCheck(
  team: CurrentTeamGq,
  keywordCount: number,
) {

  const limitOk =
    (team?.activeSubscriptionPeriod?.monthlyUseSearchVolumeKw ?? 0) + keywordCount <=
    (team?.activeSubscriptionPeriod?.monthlyCapSearchVolumeKw ?? 0);

  return {
    keywordSelectionOk: limitOk,
  };
}
